/**
 * Integrations store
 *
 * Manages integration state, connected integrations, and integration operations.
 *
 * Reference: Zustand store pattern
 * https://github.com/pmndrs/zustand
 */
import { create } from 'zustand';
export const useIntegrationsStore = create((set, get) => ({
    // State
    connectedIntegrations: [],
    isLoading: false,
    isConnecting: false,
    isDisconnecting: false,
    isSyncing: false,
    error: null,
    // Actions
    setConnectedIntegrations: (integrations) => {
        set({ connectedIntegrations: integrations });
    },
    addConnectedIntegration: (integration) => {
        set((state) => ({
            connectedIntegrations: [...state.connectedIntegrations, integration],
        }));
    },
    updateConnectedIntegration: (integrationId, updates) => {
        set((state) => ({
            connectedIntegrations: state.connectedIntegrations.map((integration) => integration.id === integrationId
                ? { ...integration, ...updates }
                : integration),
        }));
    },
    removeConnectedIntegration: (integrationId) => {
        set((state) => ({
            connectedIntegrations: state.connectedIntegrations.filter((integration) => integration.id !== integrationId),
        }));
    },
    setLoading: (isLoading) => {
        set({ isLoading });
    },
    setConnecting: (isConnecting) => {
        set({ isConnecting });
    },
    setDisconnecting: (isDisconnecting) => {
        set({ isDisconnecting });
    },
    setSyncing: (isSyncing) => {
        set({ isSyncing });
    },
    setError: (error) => {
        set({ error });
    },
    clearError: () => {
        set({ error: null });
    },
    // Helper getters
    getConnectedIntegration: (integrationId) => {
        return get().connectedIntegrations.find((integration) => integration.id === integrationId);
    },
    isIntegrationConnected: (integrationId) => {
        const integration = get().getConnectedIntegration(integrationId);
        return integration?.status === 'connected';
    },
}));
//# sourceMappingURL=integrations.js.map